import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import './ModalCajaFlujoConcepto.css';
import Loader from '../Loader/Loader';
import ProveedoresService from '../../axios_services/proveedores.service';

const getInitialState = (periodo = '') => ({
  periodo_fecha: periodo || '',
  fecha_movimiento: '',
  fecha_comprobante: '',
  caja_tipo_comprobante_id: '',
  serie: '',
  numero: '',
  ruc_proveedor: '',
  nombre_proveedor: '',
  descripcion: '',
  caja_categoria_movimiento_id: '',
  monto: '',
  caja_responsable_id: ''
});

const ModalCajaFinancieroContabilidad = ({
  onSave,
  onClose,
  isOpen,
  registroEditar,
  periodo,
  tiposComprobante,
  categoriasMovimiento,
  responsables,
  onNotify
}) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(getInitialState(periodo));
  const [proveedores, setProveedores] = useState([]);
  const [proveedorSelect, setProveedorSelect] = useState('');

  useEffect(() => {
    ProveedoresService.getProveedores().then(response => {
      setProveedores(response.data || response || []);
    }).catch(err => console.error("Error al cargar proveedores", err));
  }, []);

  useEffect(() => {
    if (isOpen) {
      if (registroEditar) {
        setFormData({
          periodo_fecha: registroEditar.periodo_fecha || periodo || '',
          fecha_movimiento: registroEditar.fecha_movimiento ? registroEditar.fecha_movimiento.substring(0, 10) : '',
          fecha_comprobante: registroEditar.fecha_comprobante ? registroEditar.fecha_comprobante.substring(0, 10) : '',
          caja_tipo_comprobante_id: registroEditar.caja_tipo_comprobante_id?.toString() || '',
          serie: registroEditar.serie || '',
          numero: registroEditar.numero || '',
          ruc_proveedor: registroEditar.ruc_proveedor || '',
          nombre_proveedor: registroEditar.nombre_proveedor || '',
          descripcion: registroEditar.descripcion || '',
          caja_categoria_movimiento_id: registroEditar.caja_categoria_movimiento_id?.toString() || '',
          monto: Math.abs(parseFloat(registroEditar.monto || 0)).toString(),
          caja_responsable_id: registroEditar.caja_responsable_id?.toString() || ''
        });
      } else {
        const hoy = new Date().toISOString().substring(0, 10);
        setFormData({
          ...getInitialState(periodo),
          periodo_fecha: periodo || '',
          fecha_movimiento: hoy
        });
        setProveedorSelect('');
      }
    }
  }, [isOpen, registroEditar, periodo]);

  useEffect(() => {
    if (isOpen && proveedores.length > 0 && registroEditar) {
      const match = proveedores.find(p => p.documento === registroEditar.ruc_proveedor && p.nombre_razon_social === registroEditar.nombre_proveedor);
      if (match) {
        setProveedorSelect(match.proveedor_id.toString());
      } else if (registroEditar.ruc_proveedor || registroEditar.nombre_proveedor) {
        setProveedorSelect('NUEVO');
      } else {
        setProveedorSelect('');
      }
    }
  }, [isOpen, registroEditar, proveedores]);

  const handleProveedorSelect = (e) => {
    const val = e.target.value;
    setProveedorSelect(val);
    if (val === 'NUEVO' || val === '') {
      setFormData(prev => ({ ...prev, ruc_proveedor: '', nombre_proveedor: '' }));
    } else {
      const prov = proveedores.find(p => p.proveedor_id.toString() === val);
      if (prov) {
        setFormData(prev => ({ ...prev, ruc_proveedor: prov.documento, nombre_proveedor: prov.nombre_razon_social }));
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);

      if (!formData.periodo_fecha || !formData.fecha_movimiento || !formData.caja_tipo_comprobante_id || !formData.nombre_proveedor.trim() || !formData.descripcion.trim() || !formData.caja_categoria_movimiento_id || formData.monto === '') {
        onNotify?.('Por favor, complete todos los campos obligatorios.', 'error');
        setLoading(false);
        return;
      }

      if (isNaN(formData.monto) || parseFloat(formData.monto) < 0) {
        onNotify?.('Ingrese un monto válido.', 'error');
        setLoading(false);
        return;
      }

      await onSave({
        periodo_fecha: formData.periodo_fecha,
        fecha_movimiento: formData.fecha_movimiento,
        fecha_comprobante: formData.fecha_comprobante || null,
        caja_tipo_comprobante_id: parseInt(formData.caja_tipo_comprobante_id, 10),
        serie: formData.serie.trim() || null,
        numero: formData.numero.trim() || null,
        ruc_proveedor: formData.ruc_proveedor.trim() || null,
        nombre_proveedor: formData.nombre_proveedor.trim(),
        descripcion: formData.descripcion.trim(),
        caja_categoria_movimiento_id: parseInt(formData.caja_categoria_movimiento_id, 10),
        monto: parseFloat(formData.monto),
        caja_responsable_id: formData.caja_responsable_id ? parseInt(formData.caja_responsable_id, 10) : null
      });
      onClose();
    } catch (error) {
      console.error("Error al guardar:", error);
      const errorMsg = error.response?.data?.message || 'Ocurrió un error al guardar.';
      onNotify?.(`Error: ${errorMsg}`, 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} className="custom-modal" backdrop="static">
      <ModalHeader className="modal-header">
        <div className="titulo">
          <h1>{registroEditar ? 'EDITAR REGISTRO CONTABLE' : 'NUEVO REGISTRO CONTABLE'}</h1>
          <Button className="close-btn" onClick={onClose}>X</Button>
        </div>
      </ModalHeader>
      <div className="modal-body-footer">
        {loading ? (
          <Loader />
        ) : (
          <ModalBody className="modal-body">
            <Form className="fila" onSubmit={(e) => e.preventDefault()}>
              <FormGroup>
                <Label>Fecha de Movimiento:</Label>
                <Input className="form-control" type="date" name="fecha_movimiento" value={formData.fecha_movimiento} onChange={handleChange} required />
              </FormGroup>

              <FormGroup>
                <Label>Fecha Comprobante:</Label>
                <Input className="form-control" type="date" name="fecha_comprobante" value={formData.fecha_comprobante} onChange={handleChange} />
              </FormGroup>

              <FormGroup>
                <Label>Tipo de Comprobante:</Label>
                <Input className="form-control" type="select" name="caja_tipo_comprobante_id" value={formData.caja_tipo_comprobante_id} onChange={handleChange} required>
                  <option value="">Seleccione...</option>
                  {tiposComprobante.map((tipo) => (
                    <option key={tipo.caja_tipo_comprobante_id} value={tipo.caja_tipo_comprobante_id}>
                      {tipo.nombre_tipo_comprobante}
                    </option>
                  ))}
                </Input>
              </FormGroup>

              <FormGroup>
                <Label>Serie:</Label>
                <Input className="form-control" type="text" name="serie" value={formData.serie} onChange={handleChange} maxLength="20" />
              </FormGroup>

              <FormGroup>
                <Label>Número:</Label>
                <Input className="form-control" type="text" name="numero" value={formData.numero} onChange={handleChange} maxLength="30" />
              </FormGroup>

              <FormGroup>
                <Label>Proveedor:</Label>
                <Input className="form-control" type="select" value={proveedorSelect} onChange={handleProveedorSelect} required>
                  <option value="">Seleccione...</option>
                  <option value="NUEVO">NUEVO (Escribir manualmente)</option>
                  {proveedores.map(p => (
                    <option key={p.proveedor_id} value={p.proveedor_id}>{p.nombre_razon_social} - {p.documento}</option>
                  ))}
                </Input>
              </FormGroup>

              <FormGroup>
                <Label>RUC Proveedor:</Label>
                <Input className="form-control" type="text" name="ruc_proveedor" value={formData.ruc_proveedor} onChange={handleChange} maxLength="20" disabled={proveedorSelect !== 'NUEVO'} />
              </FormGroup>

              <FormGroup>
                <Label>Nombre Proveedor:</Label>
                <Input className="form-control" type="text" name="nombre_proveedor" value={formData.nombre_proveedor} onChange={handleChange} maxLength="180" required disabled={proveedorSelect !== 'NUEVO'} />
              </FormGroup>

              <FormGroup>
                <Label>Descripción:</Label>
                <Input className="form-control" type="textarea" name="descripcion" value={formData.descripcion} onChange={handleChange} maxLength="2000" required />
              </FormGroup>

              <FormGroup>
                <Label>Categoría de Movimiento:</Label>
                <Input className="form-control" type="select" name="caja_categoria_movimiento_id" value={formData.caja_categoria_movimiento_id} onChange={handleChange} required>
                  <option value="">Seleccione...</option>
                  {categoriasMovimiento.map((categoria) => (
                    <option key={categoria.caja_categoria_movimiento_id} value={categoria.caja_categoria_movimiento_id}>
                      {categoria.caja_categoria_movimiento_id} - {categoria.nombre_categoria_movimiento} ({categoria.tipo === 'ingreso' ? 'Ingreso' : 'Egreso'})
                    </option>
                  ))}
                </Input>
              </FormGroup>

              <FormGroup>
                <Label>Monto:</Label>
                <div className="input-group custom-input-group">
                  <span className="input-group-text custom-symbol">S/.</span>
                  <Input className="form-control" type="number" name="monto" value={formData.monto} onChange={handleChange} step="0.01" min="0" required />
                </div>
              </FormGroup>

              <FormGroup>
                <Label>Responsable del Gasto:</Label>
                <Input className="form-control" type="select" name="caja_responsable_id" value={formData.caja_responsable_id} onChange={handleChange}>
                  <option value="">Seleccione...</option>
                  {responsables.map((responsable) => (
                    <option key={responsable.caja_responsable_id} value={responsable.caja_responsable_id}>
                      {responsable.nombre_responsable}
                    </option>
                  ))}
                </Input>
              </FormGroup>

              <FormGroup>
                <div className="button-container">
                  <Button className="button-custom" onClick={handleSubmit} disabled={loading}>
                    {registroEditar ? 'ACTUALIZAR' : 'GUARDAR'}
                  </Button>
                </div>
              </FormGroup>
            </Form>
          </ModalBody>
        )}
      </div>
    </Modal>
  );
};

export default ModalCajaFinancieroContabilidad;
